export default "__VITE_ASSET__CkRBUqKV__"